module.exports = __webpack_public_path__ + "media/images/keep-5b87b38c388d40be6742e66794e9c423.svg";